import {
    AFFILIATION_LIST,
    AFFILIATION_CREATE_SUCCESS,
    AFFILIATION_LIST_SUCCESS,
    AFFILIATION_INFO_SUCCESS,
    AFFILIATION_FILTER_HANDLING,
    AFFILIATION_SEARCH_NAME,
    AFFILIATION_UPDATE_SUCCESS,
    CLEAR_AFFILIATION_INFO,
   
  } from "../actionTypes/affiliations";
 
  const INIT_STATE = {
    // platformFilters: _PLATFORM_FILTER_DATA,
    affiliationList: [],
    isSuccess: false,
    affiliations: [],
    affiliationInfo: {},
    categories: [],
    categoryInfo: {},
    queryInfo: {
      page: 1,
      size: 10,
      next: false,
    },
    totalRecords: 0,
    page: 1,
    pages: 0,
    // columnHandling: COLUMN_HANDLING,
    searchName: "",
    searchStatus: false,
    affiliationType: "Active",
    isUpdate: false,
    isCategory: true,
    isInfo: false,
    currentStep: 0,
    isEdit: false,
  };
  
  function AffiliationReducer(state = INIT_STATE, action) {
    const { type, payload } = action;
  
    switch (type) {
      // case PLATFORM_FILTER_SUCCESS: {
      //   console.log({ payload });
      //   return {
      //     ...state,
      //     // // platformFilters: { ..._PLATFORM_FILTER_DATA, ...payload },
      //   };
      // }
      // case PLATFORM_CATEGORY_INFO: {
      //   return {
      //     ...state,
      //     categoryInfo: payload,
      //   };
      // }
      case CLEAR_AFFILIATION_INFO: {
        return {
          ...state,
          affiliationInfo: {},
        };
      }
      case AFFILIATION_LIST: {
        console.log({ payload });
        return {
          ...state,
          affiliations: payload,
        };
      }
      // case PLATFORM_CATEGORY_SUCCESS: {
      //   console.log({ payload });
      //   return {
      //     ...state,
      //     categories: payload,
      //     isCategory: false,
      //   };
      // }
      // case PLATFORM_CATEGORY_CREATE_SUCCESS: {
      //   console.log({ payload });
      //   return {
      //     ...state,
      //     categories: { payload, ...state.categories },
      //     isCategory: false,
      //   };
      // }
      // case PLATFORM_CATEGORY_UPDATE_SUCCESS: {
      //   var list = state.categories.map((row) => (row._id === payload._id ? payload : row));
      //   // console.log({ payload, info });
      //   return {
      //     ...state,
      //     categories: list.filter((row) => row.active),
      //     isCategory: false,
      //   };
      // }
      case AFFILIATION_LIST_SUCCESS: {
        return {
          ...state,
          searchStatus: false,
          affiliationList: payload.data,
          queryInfo: {
            ...payload.queryInfo,
          },
          totalRecords: payload.count,
          pages: payload.pages,
          isSuccess: false,
          isCategory: true,
          // page: payload.queryInfo.page || 0
        };
      }
  
      case AFFILIATION_CREATE_SUCCESS: {
        return {
          ...state,
          affiliationList: [payload, ...state.affiliationList],
          affiliationInfo: payload,
          currentStep: payload.currentStep + 1,
          isSuccess: true,
          isEdit: payload && payload._id ? true : false,
        };
      }
  
      case AFFILIATION_UPDATE_SUCCESS: {
        console.log({ payload });
        return {
          ...state,
          affiliationList: state.affiliationList.map(
            (obj) => (payload._id === obj._id ? payload : obj)
            // data.columnHandling.map((row) => obj.id === row)
          ),
          affiliationInfo: payload,
          currentStep: payload.currentStep + 1,
          isSuccess: true,
          isUpdate: true,
        };
      }
  
      case AFFILIATION_INFO_SUCCESS: {
        console.log({ payload });
        return {
          ...state,
          affiliationInfo: payload,
          isInfo: true,
          isEdit: true,
        };
      }
      case AFFILIATION_FILTER_HANDLING: {
        console.log({ payload });
        return {
          ...state,
          columnHandling: payload.columnHandling,
          affiliationType: payload.affiliationType,
        };
      }
      case AFFILIATION_SEARCH_NAME: {
        console.log({ payload });
        return {
          ...state,
          searchName: payload,
          searchStatus: true,
          queryInfo: { page: 1, size: state.queryInfo.size },
        };
      }
  
      default:
        return state;
    }
  }
  
  export default AffiliationReducer;
  